import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=2c824d45&lang=pug&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"
import style0 from "./Content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c824d45')) {
      api.createRecord('2c824d45', component.options)
    } else {
      api.reload('2c824d45', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=2c824d45&lang=pug&", function () {
      api.rerender('2c824d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/Content.vue"
export default component.exports